import angular from 'angular';
import roles from '@updater/angular-roles';
import { actions, selectors } from '../../state';
import { track, TRACK } from '@updater-core/lib/tracker';

const getLastRouteParamFromPath = (routeExpression) => (path) =>
  new RegExp(routeExpression).test(path) ? path.split('/').pop() : null;

const shareCodeFromPath = getLastRouteParamFromPath('^/share/');

export const AuthModule = angular.module('app.auth', [roles.name]).run(AuthRun);

function AuthRun($rootScope, $location, $q, updStore, appShell) {
  'ngInject';

  let loading = false;

  // Handles the initial state change since we need to know whether
  // the user is signed in or not and we have to wait until we get
  // the session or site-config.
  function onLoad(event, toState, toParams) {
    if (loading) {
      return;
    }

    loading = true;

    // Stop the state change from continuing until we figure out what do.
    event.preventDefault();

    const shareCode = shareCodeFromPath(location.pathname);

    const finish = () => {
      goToState(toState.name, toParams);
      loading = false;
      unsubscribeLoad();
    };

    if (shareCode) {
      updStore
        .dispatch(
          actions.siteConfig.readWithParams({
            share_code: shareCodeFromPath(location.pathname),
          })
        )
        .then(finish);
    } else if (
      appShell.interactors.session.selectors.isAuthenticated(
        appShell.interactors.session.getState()
      )
    ) {
      const sessionHeaders = selectors.session.headers(updStore.getState());
      appShell.interactors.session.actions.log(
        'Auth Module - session headers at read time',
        sessionHeaders
      );
      if (Object.keys(sessionHeaders || {}).length === 0) {
        const appShellSession = appShell.interactors.session.getState();
        const {
          app,
          ...appShellSessionHeaders
        } = appShell.interactors.session.selectors.requestHeaders(
          appShellSession
        );
        // We've reached the edge-case where users got to this point
        // which is authenticated in app shell, but missing the session headers in Mover-App
        // We know this occurs at times due to clients not supporting localStorage,
        // but there is another edge-case where this happens but is not yet reprocudible
        // So our solution here is to
        // (1) Set the session headers directly (before reading off the session) and
        // (2) Track this for further analysis.
        updStore.dispatch(actions.session.set(appShellSessionHeaders));
        track({
          object: 'auth_module_missing_headers',
          verb: TRACK,
        });
      }
      updStore.dispatch(actions.session.read()).then(finish);
    } else {
      finish();
    }
  }

  const unsubscribeLoad = $rootScope.$on('$stateChangeStart', onLoad);

  function goToState(stateName, params, options) {
    updStore.dispatch(actions.router.stateGo(stateName, params, options));
  }
}
